// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__307Hi","right":"styles_right__4KtCi"};